/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import { HELPERS } from '../../helpers/index.js';
import type { ClearProposalVoteResponse, ClearProposalVoteVars } from '../openapi-types.gen.js';

export type { ClearProposalVoteResponse, ClearProposalVoteVars } from '../openapi-types.gen.js';

export const useClearProposalVote = createMutationHook<ClearProposalVoteVars, ClearProposalVoteResponse, unknown>({
  specName: 'useClearProposalVote',
  path: '/v1/proposals/{pubkey}/vote',
  method: 'DELETE',
  resolveUrl: (vars: ClearProposalVoteVars) => `/v1/proposals/${vars.pubkey}/vote`,
  
  parseResponse: (raw: unknown): ClearProposalVoteResponse => raw as ClearProposalVoteResponse,
  optimistic: [{
    queryKey: ['proposals'],
    reconcile: false,
    entityGraph: true,
    apply: (prev: any, vars: ClearProposalVoteVars, queryKey: readonly unknown[], queryClient: any) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      next = (HELPERS.applyProposalVoteOptimistic as unknown as (prev: any, vars: ClearProposalVoteVars, queryKey: readonly unknown[], queryClient: any) => any)(next, vars, queryKey, queryClient);
      return next;
    },
  }],
  
  
});
